import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { FirmaProvider } from "./context/FirmaContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";
import { FileViewerHost } from "./components/FileViewer";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Terapie from "./pages/Terapie";
import TerapieStorico from "./pages/TerapieStorico";
import ControlloTerapie from "./pages/ControlloTerapie";
import NonMangia from "./pages/NonMangia";
import NonBeve from "./pages/NonBeve";
import SchedaOspite from "./pages/SchedaOspite";
import Prenotazioni from "./pages/Prenotazioni";
import ArchivioOspiti from "./pages/ArchivioOspiti";
import ArchivioOperatori from "./pages/ArchivioOperatori";
import SchedaOperatore from "./pages/SchedaOperatore";
import ContrattiScadutiPanel from "./components/ContrattiScadutiPanel";
import OperatoriConformitaPanel from "./components/OperatoriConformitaPanel";
import MioAccount from "./pages/MioAccount";
import Note from "./pages/Note";
import AdminConsole from "./pages/AdminConsole";
import DocumentiArchivio from "./pages/DocumentiArchivio";
import Consegne from "./pages/Consegne";
import RegistroFirme from "./pages/RegistroFirme";
import Riunioni from "./pages/Riunioni";
import PannelloSegnalazioni from "./pages/PannelloSegnalazioni";
import Alvo from "./pages/Alvo";
import Alzate from "./pages/Alzate";
import Pulizie from "./pages/Pulizie";
import MessaALetto from "./pages/MessaALetto";
import Turni from "./pages/Turni";
import PianoLavoro from "./pages/PianoLavoro";
import CheckIn from "./pages/CheckIn";
import CheckInOperatore from "./pages/CheckInOperatore";
import Pannoloni from "./pages/Pannoloni";
import Docce from "./pages/Docce";
import Infettive from "./pages/Infettive";
import ChecklistSanitaria from "./pages/ChecklistSanitaria";
import VisiteMediche from "./pages/VisiteMediche";
import ImpostazioneTerapie from "./pages/ImpostazioneTerapie";
import Parametri from "./pages/Parametri";
import Cadute from "./pages/Cadute";
import Menu from "./pages/Menu";
import MenuPasti from "./pages/MenuPasti";
import ProgrammaSpesa from "./pages/ProgrammaSpesa";
import Attivita from "./pages/Attivita";
import Strutture from "./pages/Strutture";
import Utenti from "./pages/Utenti";
import Notifiche from "./pages/Notifiche";
import Controllo from "./pages/Controllo";
import Audit from "./pages/Audit";
import NumeriUtili from "./pages/NumeriUtili";
import DocumentiAmministrazione from "./pages/DocumentiAmministrazione";
import Comunicazioni from "./pages/Comunicazioni";
import EmailMassiva from "./pages/EmailMassiva";
import Finanziario from "./pages/Finanziario";
import Ammortamenti from "./pages/Ammortamenti";
import Tasse from "./pages/Tasse";
import DashboardAmministrativa from "./pages/DashboardAmministrativa";
import Banche from "./pages/Banche";
import Excel from "./pages/Excel";
import Guida from "./pages/Guida";
import EntrateUscite from "./pages/EntrateUscite";
import Presenze from "./pages/Presenze";
import News from "./pages/News";
import NuoviContatti from "./pages/NuoviContatti";
import ReportAmmissioni from "./pages/ReportAmmissioni";
import IngressiRegistro from "./pages/IngressiRegistro";
import PreseVisione from "./pages/PreseVisione";
import SupervisorOspiti from "./pages/SupervisorOspiti";
import SupervisorRichiami from "./pages/SupervisorRichiami";
import RiepilogoBuste from "./pages/RiepilogoBuste";
import BustePagaCosti from "./components/BustePagaCosti";
import TfrF24 from "./pages/TfrF24";
import F24Mensili from "./pages/F24Mensili";
import Previsioni from "./pages/Previsioni";
import Extra from "./pages/Extra";
import ExtraDashboard from "./pages/ExtraDashboard";
import ComeFunziona from "./pages/ComeFunziona";
import Impostazioni from "./pages/Impostazioni";
import DatabasePage from "./pages/Database";
import PrivacyGDPR from "./pages/PrivacyGDPR";
import SpeseSheet from "./pages/SpeseSheet";
import DataModule from "./components/DataModule";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./components/ui/tabs";
import MonthlyModule from "./components/MonthlyModule";
import { MODULES } from "./config/modules";

const Loading = () => <div className="min-h-screen grid place-items-center text-muted-foreground">Caricamento...</div>;
const RedirCartella = () => { const l = useLocation(); return <Navigate to={`/cartella-clinica${l.search}`} replace />; };


const ospiteActive = (r, ym) => {
  const ps = (r.periodi && r.periodi.length) ? r.periodi : [{ ingresso: r.data_ingresso, dimissione: r.data_dimissione }];
  return ps.some((p) => { const i = (p.ingresso || "").slice(0, 7); const o = (p.dimissione || "").slice(0, 7); return (!i || i <= ym) && (!o || o >= ym); });
};
const operatoreActive = (r, ym) => {
  const ps = (r.periodi && r.periodi.length) ? r.periodi : [{ ingresso: r.data_assunzione, dimissione: r.data_cessazione || r.scadenza_contratto }];
  return ps.some((p) => { const i = (p.ingresso || "").slice(0, 7); const o = (p.dimissione || "").slice(0, 7); return (!i || i <= ym) && (!o || o >= ym); });
};


function Guard({ children, section }) {
  const { user, can } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (section && !can(section)) return <Layout><div className="gr-card p-10 text-center text-muted-foreground">Non hai i permessi per accedere a questa sezione.</div></Layout>;
  return <Layout>{children}</Layout>;
}

function Mod({ entity }) {
  const { can } = useAuth();
  const cfg = MODULES[entity];
  if (!can(cfg.section)) return <div className="gr-card p-10 text-center text-muted-foreground">Non hai i permessi per questa sezione.</div>;
  return <DataModule entity={entity} config={cfg} />;
}

function MMod({ entity, titleOverride, baseFilter, baseDefaults, roster, activeFn, startField, unitLabel, ensure, copyPrevious, addOspite, perStructure, hideF24, footer, header }) {
  const { can } = useAuth();
  const cfg = MODULES[entity];
  if (!can(cfg.section)) return <div className="gr-card p-10 text-center text-muted-foreground">Non hai i permessi per questa sezione.</div>;
  const config = titleOverride ? { ...cfg, title: titleOverride } : cfg;
  return <MonthlyModule entity={entity} config={config} baseFilter={baseFilter} baseDefaults={baseDefaults} roster={roster} activeFn={activeFn} startField={startField} unitLabel={unitLabel} ensure={ensure} copyPrevious={copyPrevious} addOspite={addOspite} perStructure={perStructure} hideF24={hideF24} footer={footer} header={header} />;
}

function FornitoriPage() {
  const { can } = useAuth();
  if (!can("spese")) return <div className="gr-card p-10 text-center text-muted-foreground">Non hai i permessi per questa sezione.</div>;
  return <DataModule entity="fornitori" config={MODULES.fornitori} />;
}


function BusteAdmin() {
  const { can } = useAuth();
  if (!can("buste_paga")) return <div className="gr-card p-10 text-center text-muted-foreground">Non hai i permessi per questa sezione.</div>;
  return (
    <div>
      <Tabs defaultValue="importi">
      <TabsList>
        <TabsTrigger value="importi" data-testid="tab-buste-importi">Importi buste paga</TabsTrigger>
        <TabsTrigger value="riepilogo" data-testid="tab-buste-riepilogo">Riepilogo caricamenti</TabsTrigger>
      </TabsList>
      <TabsContent value="importi" className="mt-4"><BustePagaCosti /></TabsContent>
      <TabsContent value="riepilogo" className="mt-4"><RiepilogoBuste /></TabsContent>
    </Tabs>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Guard><Dashboard /></Guard>} />

      <Route path="/ospiti" element={<Guard><MMod entity="ospiti" roster activeFn={ospiteActive} startField="data_ingresso" unitLabel="ospiti" /></Guard>} />
      <Route path="/ospiti/archivio" element={<Guard section="ospiti"><ArchivioOspiti /></Guard>} />
      <Route path="/ospiti/:id" element={<Guard><SchedaOspite /></Guard>} />
      <Route path="/operatori" element={<Guard><MMod entity="operatori" roster activeFn={operatoreActive} startField="data_assunzione" unitLabel="operatori" footer={(month) => <ContrattiScadutiPanel month={month} />} header={() => <OperatoriConformitaPanel />} /></Guard>} />
      <Route path="/operatori/archivio" element={<Guard section="operatori"><ArchivioOperatori /></Guard>} />
      <Route path="/operatori/:id" element={<Guard><SchedaOperatore /></Guard>} />
      <Route path="/mio-account" element={<Guard><MioAccount /></Guard>} />
      <Route path="/note" element={<Guard><Note /></Guard>} />
      <Route path="/guida" element={<Guard><Guida /></Guard>} />
      <Route path="/consegne" element={<Guard section="consegne"><Consegne /></Guard>} />
      <Route path="/registro-firme" element={<Guard section="consegne"><RegistroFirme /></Guard>} />
      <Route path="/riunioni" element={<Guard section="riunioni"><Riunioni /></Guard>} />
      <Route path="/segnalazioni" element={<Guard section="supervisor_ospiti"><PannelloSegnalazioni /></Guard>} />
      <Route path="/alvo" element={<Guard section="alvo"><Alvo /></Guard>} />
      <Route path="/alzate" element={<Guard section="alzate"><Alzate /></Guard>} />
      <Route path="/messa-a-letto" element={<Guard section="messa_a_letto"><MessaALetto /></Guard>} />
      <Route path="/terapie" element={<Guard><Terapie /></Guard>} />
      <Route path="/terapie/ospite/:id" element={<Guard section="terapie"><TerapieStorico /></Guard>} />
      <Route path="/controllo-terapie" element={<Guard section="controllo_terapie"><ControlloTerapie /></Guard>} />
      <Route path="/non-mangia" element={<Guard section="non_mangia"><NonMangia /></Guard>} />
      <Route path="/non-beve" element={<Guard section="non_beve"><NonBeve /></Guard>} />
      <Route path="/turni" element={<Guard section="turni"><Turni /></Guard>} />
      <Route path="/piano-lavoro" element={<Guard section="piano_lavoro"><PianoLavoro /></Guard>} />
      <Route path="/check-in" element={<Guard section="checkin"><CheckIn /></Guard>} />
      <Route path="/check-in-operatore" element={<Guard section="operatori"><CheckInOperatore /></Guard>} />
      <Route path="/pulizie" element={<Guard><Pulizie /></Guard>} />
      <Route path="/pannoloni" element={<Guard section="pannoloni"><Pannoloni /></Guard>} />
      <Route path="/docce" element={<Guard section="docce"><Docce /></Guard>} />
      <Route path="/infettive" element={<Guard section="infettive"><Infettive /></Guard>} />
      <Route path="/check-list-sanitaria" element={<Guard section="infettive"><ChecklistSanitaria /></Guard>} />
      <Route path="/cartella-clinica" element={<Guard section="visite_mediche"><VisiteMediche /></Guard>} />
      <Route path="/impostazione-terapie" element={<Guard section="impostazione_terapie"><ImpostazioneTerapie /></Guard>} />
      <Route path="/visite-mediche" element={<RedirCartella />} />
      <Route path="/parametri" element={<Guard section="parametri"><Parametri /></Guard>} />
      <Route path="/cadute" element={<Guard section="cadute"><Cadute /></Guard>} />
      <Route path="/menu" element={<Guard section="menu"><Menu /></Guard>} />
      <Route path="/menu-pasti" element={<Guard section="menu"><MenuPasti /></Guard>} />
      <Route path="/programma-spesa" element={<Guard section="menu"><ProgrammaSpesa /></Guard>} />
      <Route path="/attivita" element={<Guard section="attivita"><Attivita /></Guard>} />
      <Route path="/prese-visione" element={<Guard section="attivita"><PreseVisione /></Guard>} />
      <Route path="/ospedale" element={<Guard><MMod entity="ospedale" /></Guard>} />
      <Route path="/uscite" element={<Guard><MMod entity="uscite" /></Guard>} />
      <Route path="/visite" element={<Guard><MMod entity="visite" /></Guard>} />
      <Route path="/rette" element={<Guard><MMod entity="pagamenti" ensure copyPrevious addOspite /></Guard>} />
      <Route path="/vitto" element={<Guard section="spese"><SpeseSheet /></Guard>} />
      <Route path="/spese" element={<Guard section="spese"><SpeseSheet /></Guard>} />
      <Route path="/affitto" element={<Guard section="spese"><SpeseSheet /></Guard>} />
      <Route path="/utenze" element={<Guard section="spese"><SpeseSheet /></Guard>} />
      <Route path="/fornitori" element={<Guard><FornitoriPage /></Guard>} />
      <Route path="/buste_paga" element={<Guard><BusteAdmin /></Guard>} />
      <Route path="/tfr-f24" element={<Guard section="buste_paga"><TfrF24 /></Guard>} />
      <Route path="/f24-mensili" element={<Guard section="buste_paga"><F24Mensili /></Guard>} />
      <Route path="/controllo" element={<Guard section="controllo"><Controllo /></Guard>} />
      <Route path="/previsioni" element={<Guard section="controllo"><Previsioni /></Guard>} />
      <Route path="/extra" element={<Guard section="extra"><Extra /></Guard>} />
      <Route path="/extra-dashboard" element={<Guard section="extra"><ExtraDashboard /></Guard>} />
      <Route path="/come-funziona" element={<Guard section="doc_admin"><ComeFunziona /></Guard>} />
      <Route path="/impostazioni" element={<Guard section="impostazioni"><Impostazioni /></Guard>} />
      <Route path="/strutture" element={<Guard section="strutture"><Strutture /></Guard>} />
      <Route path="/utenti" element={<Guard section="utenti"><Utenti /></Guard>} />
      <Route path="/notifiche" element={<Guard section="notifiche"><Notifiche /></Guard>} />
      <Route path="/documenti" element={<Guard section="documenti"><DocumentiArchivio /></Guard>} />
      <Route path="/documenti-amministrazione" element={<Guard section="doc_admin"><DocumentiAmministrazione /></Guard>} />
      <Route path="/numeri-utili" element={<Guard section="numeri_utili"><NumeriUtili /></Guard>} />
      <Route path="/comunicazioni" element={<Guard section="comunicazioni"><Comunicazioni /></Guard>} />
      <Route path="/email-massiva" element={<Guard section="email_massiva"><EmailMassiva /></Guard>} />
      <Route path="/finanziario" element={<Guard section="finanziario"><Finanziario /></Guard>} />
      <Route path="/ammortamenti" element={<Guard section="finanziario"><Ammortamenti /></Guard>} />
      <Route path="/tasse" element={<Guard section="controllo"><Tasse /></Guard>} />
      <Route path="/dashboard-amministrativa" element={<Guard section="controllo"><DashboardAmministrativa /></Guard>} />
      <Route path="/banche" element={<Guard section="controllo"><Banche /></Guard>} />
      <Route path="/excel" element={<Guard section="controllo"><Excel /></Guard>} />
      <Route path="/movimenti" element={<Guard section="ospiti"><EntrateUscite /></Guard>} />      <Route path="/presenze" element={<Guard section="presenze"><Presenze /></Guard>} />
      <Route path="/news" element={<Guard section="news"><News /></Guard>} />
      <Route path="/ingressi-contatti" element={<Guard section="ingressi_contatti"><NuoviContatti /></Guard>} />
      <Route path="/ingressi-report" element={<Guard section="ingressi_report"><ReportAmmissioni /></Guard>} />
      <Route path="/ingressi-registro" element={<Guard section="ingressi_registro"><IngressiRegistro /></Guard>} />
      <Route path="/prenotazioni" element={<Guard section="prenotazioni"><Prenotazioni /></Guard>} />
      <Route path="/supervisor-ospiti" element={<Guard><SupervisorOspiti /></Guard>} />
      <Route path="/supervisor-richiami" element={<Guard section="supervisor_richiami"><SupervisorRichiami /></Guard>} />
      <Route path="/admin" element={<Guard section="adminconsole"><AdminConsole /></Guard>} />
      <Route path="/audit" element={<Guard section="audit"><Audit /></Guard>} />
      <Route path="/database" element={<Guard section="database"><DatabasePage /></Guard>} />
      <Route path="/privacy-gdpr" element={<Guard section="database"><PrivacyGDPR /></Guard>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <FirmaProvider>
            <AppRoutes />
            <Toaster position="top-right" richColors />
            <FileViewerHost />
          </FirmaProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
